import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import GuidePage from "@/pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/en" replace />,
  },
  {
    path: "/:lang",
    element: <Home />,
  },
  {
    path: "/:lang/basetao-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/:lang/guide/:slug",
    element: <GuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;